import React from "react";
import { heroMedia } from "../../data/impactStories";
import { company } from "../../data/mock";
import { ArrowRight } from "lucide-react";

const video = heroMedia.find((m) => m.type === "video");

export default function RiFinale() {
  return (
    <section data-testid="ri-finale" className="relative h-[80vh] min-h-[540px] overflow-hidden flex items-center">
      <video src={video.src} poster={video.poster} autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/60" />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-[#08080a]" />
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 w-full">
        <div className="max-w-3xl reveal">
          <h2 className="font-display text-white text-4xl sm:text-6xl lg:text-7xl font-bold leading-[1.0]">
            Building infrastructure
            <span className="block text-[#F5D000]">responsibly.</span>
          </h2>
          <p className="mt-6 text-white/75 text-lg max-w-xl leading-relaxed">
            From carbon reduction plans to social value evidence, if your framework or tender needs
            proof of how a contractor behaves, talk to us.
          </p>
          <div className="mt-9 flex flex-wrap gap-4">
            <a href="/#contact" data-testid="finale-talk-btn" className="btn-amber px-8 py-4 rounded-md text-sm font-semibold inline-flex items-center gap-2 group">
              Talk to our team <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <a href={`mailto:${company.email}?subject=Responsible Infrastructure Enquiry`} data-testid="finale-email-btn" className="btn-ghost px-8 py-4 rounded-md text-sm font-semibold">
              {company.email}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
